export default () => ({
  isConfigsLoading: false,
  configs: {},
  isVisualisationsLoading: false,
  isVisualisationObjectsLoading: false,
  visualisationsNextPage: 1,
  visualisationObjects: {},
  visualisations: {},
});
